<script lang="ts">export let size = "20";
const height = size;
</script>

<svg {height} style="fill:currentColor" viewBox="0 0 21 18" xmlns="http://www.w3.org/2000/svg">
	<path
		opacity=".07"
		fill-rule="evenodd"
		clip-rule="evenodd"
		d="M3.772.088.015 7.978a.15.15 0 0 0 .033.178l10.145 9.721c.06.057.154.057.214 0l10.144-9.72a.15.15 0 0 0 .033-.179L16.828.088A.15.15 0 0 0 16.689 0H3.911a.15.15 0 0 0-.14.088"
	/>
	<!-- fill="#DBDBDB" -->
	<path
		fill-rule="evenodd"
		clip-rule="evenodd"
		d="M11.603 8.788c-.073.005-.449.028-1.288.028-.668 0-1.142-.02-1.308-.028-2.58-.114-4.506-.563-4.506-1.1S6.427 6.7 9.007 6.585V8.34c.169.012.652.04 1.32.04.8 0 1.201-.033 1.274-.04V6.587c2.574.115 4.496.564 4.496 1.1s-1.921.986-4.496 1.1zm0-2.382v-1.57h3.593V2.44H5.414v2.395h3.592v1.57c-2.92.133-5.115.712-5.115 1.405s2.195 1.27 5.115 1.405v5.032h2.597V9.214c2.913-.134 5.105-.711 5.105-1.404 0-.692-2.19-1.27-5.105-1.404"
	/>
</svg>
